import classNames from "classnames";
import React from "react";

const StepLg = ({ img, number, descripcion, lines = false }) => {
  return (
    <div
      className={classNames("step", {
        lines: lines,
      })}>
      <div className='d-flex flex-row justify-content-center'>
        <div className='step__data'>
          <div className='d-flex flex-row justify-content-center'>
            <h1 className='step__number align-self-center my-0 p-0 align-self-lg-center'>
              {number}
            </h1>
            <img src={img} className='step__icon' alt='' />
          </div>
          <p style={{ fontSize: "20px" }}>{descripcion}</p>
        </div>
      </div>
    </div>
  );
};

export default StepLg;
